export const logsTypesOrder = ["currentTurn", "player", "opponent"]
